import {useTranslation} from 'react-i18next'

import {PencilWritingIcon} from '~/react/icons/PencilWritingIcon'

export const stepName = 'acceptTerms'

const calculateStatus = ({acceptedTermsAndConditions}) => {
  if (acceptedTermsAndConditions) {
    return 'completed'
  }

  return 'incomplete'
}

export const useAcceptTermsStep = ({openTermsModal, ...stepperData}) => {
  const {t} = useTranslation('points')

  const i18nPrefix =
    'points:dashboardScreen.onboardingStepper.steps.acceptTerms'

  const onClick = async () => {
    await openTermsModal()
  }

  return {
    name: stepName,
    status: calculateStatus(stepperData),
    icon: <PencilWritingIcon />,
    title: t(`${i18nPrefix}.title`),
    subtitle: {
      default: t(`${i18nPrefix}.subtitle.incomplete`),
      completed: t(`${i18nPrefix}.subtitle.completed`),
    },
    action: {
      label: t(`${i18nPrefix}.actionLabel`),
      onClick,
    },
  }
}
